import {
  ColumnModel,
  SortingState,
  TableApi,
  TableComponents,
  RowKey,
} from '../types';

type Props<T, K extends RowKey> = {
  api: TableApi<T, K>;
  columnModel: ColumnModel<T, K>;
  SortIcon: Required<TableComponents<T, K>>['SortIcon'];
};

const getNextSortingState = <T, K extends RowKey>(
  columnModel: ColumnModel<T, K>,
  currentSortingState?: SortingState<T>
): SortingState<T> | undefined => {
  if (currentSortingState?.columnId !== columnModel.id) {
    return {
      columnId: columnModel.id,
      sortBy: { accessor: columnModel.accessor!, direction: 'asc' },
    };
  }
  if (currentSortingState.sortBy.direction === 'asc') {
    return {
      columnId: columnModel.id,
      sortBy: { accessor: columnModel.accessor!, direction: 'desc' },
    };
  }
  return undefined;
};

export const Sorter = <T, K extends RowKey = RowKey>({
  api,
  columnModel,
  SortIcon,
}: Props<T, K>) => {
  const { id } = columnModel;
  if (!columnModel.sortable) {
    return null;
  }

  const direction =
    api.state.sortingState?.columnId === id
      ? api.state.sortingState?.sortBy.direction
      : undefined;

  return (
    <SortIcon
      sortDirection={direction}
      onClick={() =>
        api.sortColumn(getNextSortingState(columnModel, api.state.sortingState))
      }
    />
  );
};
